(function () {
  'use strict';

  var currentVariant = null;
  var isApplying = false;

  function initVariantThumbnailSelector(wrap) {
    var productId = wrap.dataset.productId;
    var dataEl = document.getElementById('vts-' + productId + '-data');
    if (!dataEl) return;

    var data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var options = wrap.querySelectorAll('.vts-option');

    options.forEach(function (label) {
      label.addEventListener('click', function () {
        if (label.classList.contains('vts-option--soldout')) return;

        options.forEach(function (l) { l.classList.remove('vts-option--selected'); });
        label.classList.add('vts-option--selected');

        var variantId = label.dataset.variantId;
        var optionValue = label.dataset.value;
        var variant = data.variants.find(function (v) { return v.id == variantId; });

        if (variant) {
          currentVariant = variant;
          applyVariantDisplay(variant);
        }

        updateVariantId(wrap, variantId, optionValue);

        wrap.dispatchEvent(new CustomEvent('vts:variant-changed', {
          bubbles: true,
          detail: { variantId: parseInt(variantId, 10), variant: variant }
        }));
      });
    });

    var priceWrapper = document.querySelector('[id^="price-"]');
    if (priceWrapper) {
      var observer = new MutationObserver(function () {
        if (isApplying || !currentVariant) return;
        isApplying = true;
        applyVariantDisplay(currentVariant);
        setTimeout(function () { isApplying = false; }, 100);
      });
      observer.observe(priceWrapper, { childList: true, subtree: true });
    }

    var cartBtn = document.querySelector('product-form [name="add"]');
    if (cartBtn) {
      var btnObserver = new MutationObserver(function () {
        if (!currentVariant) return;
        if (currentVariant.available && cartBtn.disabled) {
          cartBtn.disabled = false;
          cartBtn.classList.remove('loading', 'disabled');
        }
      });
      btnObserver.observe(cartBtn, {
        attributes: true,
        attributeFilter: ['disabled', 'class']
      });
    }
  }

  function applyVariantDisplay(variant) {
    updatePriceImmediately(variant);
    updateDiscountBadgeImmediately(variant);
    updateCartButton(variant);
  }

  function updatePriceImmediately(variant) {
    var price = (variant.price / 100).toLocaleString('ja-JP', {
      style: 'currency', currency: 'JPY'
    });

    var salePriceEls = document.querySelectorAll('.price-item--sale');
    salePriceEls.forEach(function (el) {
      el.textContent = price;
    });

    var regularPriceEls = document.querySelectorAll('.price__regular .price-item--regular');
    regularPriceEls.forEach(function (el) {
      el.textContent = price;
    });

    if (variant.compare_at_price) {
      var comparePrice = (variant.compare_at_price / 100).toLocaleString('ja-JP', {
        style: 'currency', currency: 'JPY'
      });
      var comparePriceEls = document.querySelectorAll('s.price-item--regular');
      comparePriceEls.forEach(function (el) {
        el.textContent = comparePrice;
      });
    }
  }

  function updateDiscountBadgeImmediately(variant) {
    document.querySelector('.custom-discount-badge')?.remove();
    if (!variant.compare_at_price || variant.compare_at_price <= variant.price) return;
    var off = Math.round((1 - variant.price / variant.compare_at_price) * 100);
    var original = (variant.compare_at_price / 100).toLocaleString('ja-JP');
    var badge = document.createElement('div');
    badge.className = 'custom-discount-badge';
    badge.innerHTML = '通常価格 ¥' + original + ' より <strong>' + off + '% OFF</strong>';
    badge.style.cssText = 'font-size:0.85em; color:#c00; margin-top:4px;';
    var priceWrapper = document.querySelector('[id^="price-"]');
    if (priceWrapper) {
      priceWrapper.parentNode.insertBefore(badge, priceWrapper.nextSibling);
    }
  }

  function updateCartButton(variant) {
    var btn = document.querySelector('product-form [name="add"]');
    if (!btn) return;
    if (variant.available) {
      btn.disabled = false;
      btn.classList.remove('loading', 'disabled', 'sold-out');
    } else {
      btn.disabled = true;
      btn.classList.add('sold-out');
    }
  }

  function updateVariantId(wrap, variantId, optionValue) {
    var productForm = document.querySelector('product-form');
    if (productForm) {
      var hiddenInput = productForm.querySelector('input[name="id"]');
      if (hiddenInput) { hiddenInput.value = variantId; }
    }
    var form = wrap.closest('form[action="/cart/add"]');
    if (form) {
      var idInput = form.querySelector('input[name="id"]');
      if (idInput) { idInput.value = variantId; }
    }

    if (history && history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variantId);
      history.replaceState({}, '', url.toString());
    }
  }

  function init() {
    document.querySelectorAll('.vts-wrap').forEach(function (wrap) {
      initVariantThumbnailSelector(wrap);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();